import * as types from "./types";

export const fetchCallLogs = (payload?: any) => ({
  type: types.FETCH_CALL_LOGS,
  payload,
});
export const fetchIvrMenus = (payload?: any) => ({
  type: types.FETCH_IVR_MENUS,
  payload,
});

export const syncIvrMenus = (payload?: any) => ({
  type: types.SYNC_IVR_MENUS,
  payload,
});

export const syncExtensions = (payload?: any) => ({
  type: types.SYNC_EXTENSIONS,
  payload,
});

export const customerInfo = (payload: any) => ({
  type: types.FETCH_CUSTOMER_INFO,
  payload,
});

export const postCallCustomerInfo = (payload: any) => ({
  type: types.FETCH_POST_CALL_CUSTOMER_INFO,
  payload,
});

export const fetchCallDetail = (sessionId: string) => ({
  type: types.FETCH_CALL_DETAIL,
  payload: sessionId,
});

export const updateCallLog = (sessionId: string, body: any) => ({
  type: types.UPDATE_CALL_LOG,
  payload: { sessionId, body },
});

export const updateTransferCallLog = ( body: any) => ({
  type: types.UPDATE_TRANSFER_CALL_LOG,
  payload: { body },
});


export const queueCalls = (payload?: any) => ({
  type: types.FETCH_QUEUE_CALLS,
  payload,
});

export const queueTransferCalls = (payload?: any) => ({
  type: types.FETCH_QUEUE_TRANSFER_CALLS,
  payload,
});

export const totalCountsQueueCalls = () => ({
  type: types.FETCH_TOTAL_COUNT_QUEUE__CALLS,
});

export const fetchCallStats = () => ({
  type: types.FETCH_CALL_STATS,
});

export const fetchCallLogsDetails = (payload?: any) => ({
  type: types.FETCH_CALL_LOGS_DETAILS,
  payload,
});

export const fetchCallLogsGetExtension = () => ({
  type: types.FETCH_CALL_LOGS_GET_EXTENSIONS,
});
